import axios from 'axios'

export default {
  state: {
    selectedVideo: null,
    videoArray: [],
    videoListDisplay: false
  },
  mutations: {
    SET_SELECTED_VIDEO (state, video) {
      state.selectedVideo = video
    },
    SET_VIDEO_LIST_DISPLAY (state, value) {
      state.videoListDisplay = value
    },
    SET_VIDEO_ARR (state, video) {
      state.videoArray.push(video)
    },
    CLEAR_VIDEO_ARR (state) {
      state.videoArray = []
    }
  },
  actions: {
    setSelectedVideo ({ commit }, video) {
      commit('SET_SELECTED_VIDEO', video)
    },
    setVideoListDisplay ({ commit }, value) {
      commit('SET_VIDEO_LIST_DISPLAY', value)
    },
    searchYoutube ({ commit }, youtubeObj) {
      return axios.get('https://www.googleapis.com/youtube/v3/search?', {
        params: {
          part: 'snippet',
          q: youtubeObj.searchInput,
          key: youtubeObj.apiKey,
          maxResults: 20,
          type: 'video',
          videoEmbeddable: true
        }
      }).then((response) => {
        commit('CLEAR_VIDEO_ARR')
        for (let i = 0; i < response.data.items.length; i++) {
          const video = {
            title: response.data.items[i].snippet.title,
            videoURL: 'https://www.youtube.com/embed/' + response.data.items[i].id.videoId,
            description: response.data.items[i].snippet.description
          }
          commit('SET_VIDEO_ARR', video)
        }
      }).catch(error => console.log(error))
    },
    clearArr ({ commit }) {
      commit('CLEAR_VIDEO_ARR')
    }
  }
}
